<template>
    <vx-card class="limited-max-width" id="pack-offers">
      <div>
        <header-step-process-component
          v-bind:step="step">
        </header-step-process-component>


        <div v-if="commercialOffer.type == 'PAQUETES'">
          <commercial-offer-pack
            v-bind:commercialOffer="commercialOffer"
            v-bind:code="code"
            v-bind:next="next"
            v-bind:previus="previus"
          >
          </commercial-offer-pack>
        </div>

        <!-- <div v-if="commercialOffer.type == 'PRODUCTO'">
          <commercial-offer-single-product
            v-bind:commercialOffer="commercialOffer"
            v-bind:code="code"
            v-bind:next="next"
            v-bind:previus="previus"
          >
          </commercial-offer-single-product>
        </div> -->
        
        <div v-if="commercialOffer.type == 'LIBRE'">
          <commercial-offer-multiple-products
            v-bind:commercialOffer="commercialOffer"
            v-bind:code="code"
            v-bind:next="next"
            v-bind:previus="previus"
          >
          </commercial-offer-multiple-products>
        </div>

        
      </div>

    </vx-card>
</template>

<script>
/* eslint-disable */
import VxCard from '../../components/vx-card/VxCard.vue'
import HeaderStepProcessComponent from '../components/eprevision-components/header/HeaderStepProcessComponent.vue';
// import CommercialOfferSingleProduct from '../components/eprevision-components/commercialOfferSingleProduct/CommercialOfferSingleProduct.vue'
import CommercialOfferMultipleProducts from '../components/eprevision-components/commercialOfferMultipleProducts/CommercialOfferMultipleProducts.vue'

import CommercialOfferPack from '../components/eprevision-components/commercialOfferPack/CommercialOfferPack.vue'
import axios from '../../http/axios/index.js'

export default {
  components: {
      VxCard,
      HeaderStepProcessComponent,
      // CommercialOfferSingleProduct,
      CommercialOfferMultipleProducts,
      CommercialOfferPack
    },
    data() {
      return {
        step: 2,
        code: this.$route.params.code,
        next: "commercial-offer/third",
        previus: "commercial-offer/first",
        dataStored: null,
        commercialOffer: null,
      }
    },
    created() {
      this.$vs.loading.close()
  
      this.dataStored = JSON.parse(localStorage.getItem(this.code))

      this.commercialOffer = this.dataStored.commercialOffer
      
    },

}
</script>
